export const CHART_AGGREGATORS = {
  HIGH: 'high',
  AVERAGE: 'average',
  LOW: 'low',
  SUM: 'sum',
  CUSTOM_FREQUENCY: 'customFrequency',
  WEIGHTED_AVERAGE: 'weightedAverage',
};

export const AGGREGATORS = {
  HIGH: 'high',
  AVERAGE: 'average',
  LOW: 'low',
  CLOSE: 'close',
  COUNT: 'count',
  SUM: 'sum',
  FREQUENCY: 'frequency',
  PERCENTAGE: 'percentage',
  WEIGHTED_AVERAGE: 'weightedAverage',
};

/** Stored on chartPhaseLines documents; a document without one is a phase line. */
export const CHART_LINE_TYPE = /** @type {const} */ ({
  PHASE: 'phase',
  EVENT: 'event',
});

/** @typedef {typeof CHART_LINE_TYPE[keyof typeof CHART_LINE_TYPE]} ChartLineType */

export const CHART_TYPE = {
  COLUMN: 'column',
  LINE: 'line',
  LINECHART: 'linechart',
  SCATTERCHART: 'scatterchart',
  SCATTERPLOT: 'scatterplot',
  LOGARITHMIC: 'logarithmic',
  STACKED: 'stacked',
};

/**
 * Data series presets,
 * used in Insights mixin + Data Sources
 */
export const DS_ID = {
  ASSESSMENT: 'dsAssessmentData',
  BEHAVIOR_INCIDENT: 'dsBehaviorIncidentDataFlat',
  SESSION: 'dsSessionData',
  SESSION_TRIAL: 'dsSessionTrialData',
  TARGETS: 'dsTargets',
};

/**
 * @returns {object} a fresh blank dataSeriesSettings
 */
export function createBlankDataSeriesSettings() {
  return {
    dataSource: '',
    preloadFilter: null,
    postloadFilter: {},
    dataSeriesPreset: null,
    dataProperty: null,
    aggregator: null,
    chartType: null,
    groupByDataProperty: null,
    analysis: { trendline: false, average: false },
  };
}
